"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgSort = props => (0, jsx_runtime_1.jsxs)("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  style: {
    marginTop: `${!props.sort ? 0 : props.sort === 'asc' ? '-4px' : '4px'}`
  }
}, props, {
  children: [(0, jsx_runtime_1.jsx)("path", {
    "data-name": "Rectangle 471",
    fill: "none",
    d: "M0 0h14v14H0z"
  }, void 0), (!props.sort || props.sort === 'asc') && (0, jsx_runtime_1.jsx)("path", {
    "data-name": "Path 180",
    d: "M3.5 8.015h7l-3.5 3.5z",
    fill: "#919191"
  }, void 0), (!props.sort || props.sort === 'desc') && (0, jsx_runtime_1.jsx)("path", {
    "data-name": "Path 293",
    d: "M10.501 5.985h-7l3.5-3.5z",
    fill: "#919191"
  }, void 0)]
}), void 0);

exports.default = SvgSort;